import actionTypes from './actionTypes';

const requestGameTypeData = () => ({
    type: actionTypes.REQUEST_GAMETYPE_DATA
});

const gameTypeResponse = (success, gameTypes, error) => ({
    type: actionTypes.GAMETYPE_DATA_RESPONSE,
    payload: {
        success: success,
        gameTypeData: gameTypes.data,
        errors: error
    }
});

const changeGameTypeValue = (gameType) => ({
    type: actionTypes.CHANGE_GAMETYPE_VALUE,
    payload: {
        id: gameType.id,
        value: gameType.value,
        label: gameType.label
    }
});

const requestReportData = () => ({
    type: actionTypes.REQUEST_REPORT_DATA
});

const reportDataResponse = (success, url, error = []) => ({
    type: actionTypes.REPORT_DATA_RESPONSE,
    payload: {
        success,
        url,
        errors: error
    }
});

const changeReportSelection = (value, selectedReports, isChecked) => ({
    type: actionTypes.CHANGE_REPORT_SELECTION,
    payload: {
        reportType: value,
        selectedReports: selectedReports,
        isChecked: isChecked
    }
});

const hydrateTeamFilter = (selectedTeams) => ({
    type: actionTypes.HYDRATE_TEAM_FILTER,
    payload: {
        selectedTeams: selectedTeams
    }
});

const changeTeamSelection = (id, availableTeams, isChecked) => ({
    type: actionTypes.CHANGE_TEAM_SELECTION,
    payload: {
        teamId: id,
        availableTeams: availableTeams,
        isChecked: isChecked
    }
});

const changeAllSelection = (id, availableTeams, isChecked) => ({
    type: actionTypes.CHANGE_ALL_SELECTION,
    payload: {
        id: id,
        availableTeams: availableTeams,
        isChecked: isChecked
    }
});

export default {
    requestReportData,
    reportDataResponse,
    requestGameTypeData,
    gameTypeResponse,
    changeGameTypeValue,
    changeReportSelection,
    changeTeamSelection,
    changeAllSelection,
    hydrateTeamFilter
}